import styled from "styled-components";
import { theme } from "theme";

export const Wrapper = styled.div`
  padding: 30px 0;

  @media (max-width: ${theme.breakpoints.sm}) {
    width: 100%;
    padding: 80px 16px 30px 16px;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 30px 190px;
  max-width: 692px;
  max-height: 484px;
  width: 100%;
  height: 100%;
  background: #f9f2ec;
  border-radius: 8px;
  margin-top: 50px;

  @media (max-width: ${theme.breakpoints.sm}) {
    margin: auto;
    padding: 32px;
    max-height: 630px;
  }
`;

export const FormParent = styled.div`
  width: 100%;
`;

export const ForgotPassword = styled.div`
  font-size: 10px;
  color: ${theme.palette.primary};
  margin-top: -10px;
  cursor: pointer;
  text-decoration: underline;
`;
